import { render, staticRenderFns } from "./AddStage.vue?vue&type=template&id=3631e342&scoped=true"
import script from "./AddStage.vue?vue&type=script&lang=js"
export * from "./AddStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3631e342",
  null
  
)

export default component.exports